import { Modal } from "bootstrap";
import {
    forwardRef,
    useImperativeHandle,
    useRef,
    useState,
} from "react";

import * as b2bleadService from "../../Services/b2bleadService";
import { toast } from "react-toastify";

const MoveLeadFromB2B = forwardRef((props, ref) => {

    const {
        selectedLeads,
        setSelectedLeads,
        getLeadData,
    } = props;

    const modalRef = useRef(null);
    const bsModal = useRef(null);
    const [leadIds, setLeadIds] = useState([]);

    const [submitLoader, setSubmitLoader] = useState(false);

    const handleClose = () => {
        bsModal.current?.hide();
    };

    useImperativeHandle(ref, () => ({
        toggle(id) {
            if (!bsModal.current) {
                bsModal.current = new Modal(modalRef.current);
            }

            if (id) {
                // Single move
                setLeadIds([id]);
            } else {
                // Bulk move
                setLeadIds(selectedLeads);
            }

            bsModal.current.show();
        },

        close() {
            handleClose();
        },
    }));

    const handleMove = async () => {
        try {
            setSubmitLoader(true);

            const res = await b2bleadService.moveToB2C(leadIds);

            if (res?.data?.status === "success") {
                toast.success(res.data.message);

                setSelectedLeads([]);
                setLeadIds([]);

                getLeadData();

                handleClose();
            }

        } catch (err) {
            console.log(err);
            toast.error("Failed to move lead(s)");
        } finally {
            setSubmitLoader(false);
        }
    };

    return (
        <div
            className="modal fade"
            ref={modalRef}
            tabIndex="-1"
            aria-hidden="true"
            style={{
                background: "rgba(15,23,42,0.55)",
                backdropFilter: "blur(5px)",
            }}
        >
            <div
                className="modal-dialog modal-dialog-centered"
                style={{
                    maxWidth: "500px",
                }}
            >
                <div
                    className="modal-content border-0 rounded-4"
                >

                    {/* Header */}

                    <div
                        className="modal-header border-0 text-white"
                        style={{
                            background:
                                "linear-gradient(135deg,#2563eb,#1d4ed8)",
                        }}
                    >

                        <div>

                            <h5 className="mb-0 fw-bold">
                                Move Lead
                            </h5>

                            <p className="mb-0 small opacity-75">
                                Lead Transfer Confirmation
                            </p>

                        </div>

                        <button
                            type="button"
                            className="btn btn-light rounded-circle position-absolute"
                            style={{
                                top: "10px",
                                right: "18px",
                                width: "38px",
                                height: "38px",
                            }}
                            onClick={handleClose}
                        >
                            <i className="fa fa-times"></i>
                        </button>

                    </div>

                    {/* Body */}

                    <div className="modal-body text-center py-5">

                        <div
                            className="mx-auto d-flex align-items-center justify-content-center rounded-circle mb-4"
                            style={{
                                width: "80px",
                                height: "80px",
                                background: "#eef4ff",
                            }}
                        >

                            <i
                                className="fa fa-exchange-alt text-primary"
                                style={{
                                    fontSize: "34px",
                                }}
                            />

                        </div>

                        <h4 className="fw-bold mb-3">
                            Move Lead to B2C
                        </h4>

                        <p
                            className="text-muted mb-0"
                            style={{
                                fontSize: "15px",
                            }}
                        >
                            Are you sure you want to move the selected{" "}
                            <strong>{leadIds.length}</strong> lead(s)
                            from <strong>B2B</strong> to{" "}
                            <strong>B2C</strong>?
                        </p>

                    </div>

                    {/* Footer */}

                    <div className="modal-footer border-0 px-4 pb-4">

                        <button
                            type="button"
                            className="btn btn-light border rounded-pill px-4"
                            onClick={handleClose}
                        >
                            No
                        </button>

                        <button
                            type="button"
                            className="btn btn-primary rounded-pill px-4"
                            disabled={submitLoader}
                            onClick={handleMove}
                        >
                            {
                                submitLoader
                                    ? "Moving..."
                                    : "Yes, Move"
                            }
                        </button>

                    </div>

                </div>
            </div>
        </div>
    );
});

export default MoveLeadFromB2B;